import { Directive } from '@angular/core';

@Directive({
    selector: '[sHomeStep]',
    standalone: false
})
export class StepDirective {
}
